(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-v2"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-wide-card-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      var tabs = root.querySelectorAll('[data-tab-target]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      if (!tabs.length || !panels.length) return;

      function activate(target) {
        tabs.forEach(function (t) {
          var active = t.dataset.tabTarget === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var active = p.dataset.tabPanel === target;
          p.classList.toggle('is-active', active);
          if (active) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.dataset.tabTarget);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          var list = Array.prototype.slice.call(tabs);
          var idx = list.indexOf(tab);
          var next = event.key === 'ArrowRight' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
          list[next].focus();
          activate(list[next].dataset.tabTarget);
        });
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-wide-card-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bkp"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mts-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  class MtsPdpTabs {
    constructor(root) {
      this.root = root;
      this.tabs = root.querySelectorAll('[data-pdp-tab]');
      this.panels = root.querySelectorAll('[data-pdp-panel]');
      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.pdpTab));
      });
    }

    activate(name) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.pdpTab === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.pdpPanel === name;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  function initMtsPdpTabs(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-pdp-tabs]').forEach((el) => {
      if (el.dataset.pdpTabsInit === '1') return;
      el.dataset.pdpTabsInit = '1';
      new MtsPdpTabs(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMtsPdpTabs());
  } else {
    initMtsPdpTabs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMtsPdpTabs(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mts-shop-scenarios"] && !Shopify.designMode) return;
  try {
    
  class MtsShopScenarios {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-shop-scenarios-viewport]');
      this.dots = root.querySelector('[data-shop-scenarios-dots]');
      if (!this.viewport || !this.dots) return;

      this.items = Array.from(this.viewport.children);
      if (this.items.length === 0) return;

      this.totalPages = 1;
      this.slidesPerPage = 1;
      this.step = 0;
      this.scheduled = false;

      this.onScroll = this.onScroll.bind(this);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.addEventListener('click', (event) => {
        const btn = event.target.closest('.mts-shop-scenarios__dot');
        if (!btn) return;
        const page = parseInt(btn.dataset.page, 10);
        if (Number.isFinite(page)) this.goToPage(page);
      });

      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.measure();

      // Scroll-into-view hint: peek the next slide once when the section
      // first enters the viewport so users notice this is a slider.
      this.peeked = false;
      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.peeked) {
                this.peek();
                this.viewportObserver.disconnect();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.viewportObserver.observe(this.root);
      }
    }

    peek() {
      if (this.peeked) return;
      this.peeked = true;

      if (this.totalPages <= 1 || !this.step) return;

      // Respect users who've asked the OS to reduce motion.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // If the user has already scrolled the strip themselves, don't yank
      // it back to the start mid-interaction.
      if (this.viewport.scrollLeft > 4) return;

      // scroll-snap-type: x mandatory in the CSS would snap our small
      // offset right back to 0, killing the peek visually. Disable snap
      // for the duration of the animation, then restore.
      const originalSnap = this.viewport.style.scrollSnapType;
      this.viewport.style.scrollSnapType = 'none';

      const offset = Math.round(this.step * 0.6);
      this.viewport.scrollTo({ left: offset, behavior: 'smooth' });

      setTimeout(() => {
        this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(() => {
          this.viewport.style.scrollSnapType = originalSnap;
        }, 700);
      }, 700);
    }

    measure() {
      const first = this.items[0];
      if (!first) return;

      const firstRect = first.getBoundingClientRect();
      const itemWidth = firstRect.width;
      if (!itemWidth) return;

      let gap = 0;
      if (this.items.length > 1) {
        const secondRect = this.items[1].getBoundingClientRect();
        gap = secondRect.left - firstRect.right;
      }

      this.step = itemWidth + gap;

      // slidesPerPage must be based on the CONTENT width (viewport minus its
      // left/right padding), not clientWidth — otherwise the count includes
      // space the items can't actually occupy and the page math overshoots
      // the real scrollable range, leaving the last page unreachable.
      const styles = window.getComputedStyle(this.viewport);
      const padLeft = parseFloat(styles.paddingLeft) || 0;
      const padRight = parseFloat(styles.paddingRight) || 0;
      const contentWidth = Math.max(0, this.viewport.clientWidth - padLeft - padRight);
      this.slidesPerPage = Math.max(1, Math.floor(contentWidth / this.step));

      if (this.items.length <= this.slidesPerPage) {
        this.totalPages = 1;
      } else {
        this.totalPages = Math.ceil(this.items.length / this.slidesPerPage);
      }

      this.renderDots();
      this.updateActiveDot();
    }

    setActiveDot(page) {
      const buttons = this.dots.querySelectorAll('.mts-shop-scenarios__dot');
      buttons.forEach((btn, i) => {
        const active = i === page;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    renderDots() {
      if (this.totalPages <= 1) {
        this.dots.setAttribute('hidden', '');
        this.dots.innerHTML = '';
        return;
      }
      this.dots.removeAttribute('hidden');

      const markup = [];
      for (let i = 0; i < this.totalPages; i++) {
        markup.push(
          '<button type="button" class="mts-shop-scenarios__dot" role="tab" aria-label="Go to page ' +
            (i + 1) +
            '" data-page="' +
            i +
            '"></button>'
        );
      }
      this.dots.innerHTML = markup.join('');
    }

    goToPage(page) {
      const clamped = Math.max(0, Math.min(this.totalPages - 1, page));
      const target = clamped * this.slidesPerPage * this.step;
      // Reflect the clicked page on the dots immediately. The scroll-driven
      // updateActiveDot may otherwise compute the wrong page when the last
      // page's target exceeds max scrollLeft and snap lands short of it.
      this.setActiveDot(clamped);
      this.viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    onScroll() {
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        this.scheduled = false;
        this.updateActiveDot();
      });
    }

    updateActiveDot() {
      if (this.totalPages <= 1 || !this.step) return;
      const pageWidth = this.slidesPerPage * this.step;
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      // If the viewport is scrolled to its max, force the last page so the
      // dot matches the visible end even when the target couldn't be reached.
      let page;
      if (maxScroll > 0 && this.viewport.scrollLeft >= maxScroll - 1) {
        page = this.totalPages - 1;
      } else {
        page = Math.round(this.viewport.scrollLeft / pageWidth);
      }
      const clamped = Math.max(0, Math.min(this.totalPages - 1, page));
      this.setActiveDot(clamped);
    }
  }

  function initMtsShopScenarios(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-shop-scenarios]').forEach((el) => {
      if (el.dataset.shopScenariosInit === '1') return;
      el.dataset.shopScenariosInit = '1';
      new MtsShopScenarios(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMtsShopScenarios());
  } else {
    initMtsShopScenarios();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMtsShopScenarios(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INTERVAL_MS = 5000; // advance every 5s
    var RESUME_DELAY_MS = 7000; // pause 7s after user touches/hovers
    var mq = window.matchMedia('(max-width: 749px)');

    function initSlider(slider) {
      if (slider.dataset.autoslideInited) return;
      slider.dataset.autoslideInited = 'true';

      var items = slider.querySelectorAll('.press-reviews__item');
      if (items.length < 2) return;

      // The dots container is a sibling of <ul> inside the slider-component
      // wrapper. Walk up once and query.
      var sliderComponent = slider.closest('slider-component');
      var dots = sliderComponent ? sliderComponent.querySelector('[data-press-reviews-dots]') : null;

      var index = 0;
      var interval = null;
      var pauseUntil = 0;

      function slideStep() {
        // distance between two consecutive slide starts (slide width + margin-right)
        var rect1 = items[0].getBoundingClientRect();
        var rect2 = items[1] ? items[1].getBoundingClientRect() : null;
        return rect2 ? rect2.left - rect1.left : rect1.width;
      }

      function renderDots() {
        if (!dots) return;
        var markup = '';
        for (var i = 0; i < items.length; i++) {
          markup +=
            '<button type="button" class="press-reviews__dot" role="tab" aria-label="Go to slide ' +
            (i + 1) +
            '" data-slide="' +
            i +
            '"></button>';
        }
        dots.innerHTML = markup;
        dots.removeAttribute('hidden');
      }

      function updateActiveDot() {
        if (!dots) return;
        var buttons = dots.querySelectorAll('.press-reviews__dot');
        for (var i = 0; i < buttons.length; i++) {
          var active = i === index;
          buttons[i].classList.toggle('is-active', active);
          buttons[i].setAttribute('aria-selected', active ? 'true' : 'false');
        }
      }

      function goToSlide(i) {
        index = Math.max(0, Math.min(items.length - 1, i));
        slider.scrollTo({ left: index * slideStep(), behavior: 'smooth' });
        updateActiveDot();
        pauseUntil = Date.now() + RESUME_DELAY_MS;
      }

      function advance() {
        if (Date.now() < pauseUntil) return;
        index = (index + 1) % items.length;
        slider.scrollTo({ left: index * slideStep(), behavior: 'smooth' });
        updateActiveDot();
      }

      function start() {
        stop();
        if (!mq.matches) return;
        interval = setInterval(advance, INTERVAL_MS);
      }

      function stop() {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      }

      var pauseHandler = function () {
        pauseUntil = Date.now() + RESUME_DELAY_MS;
      };
      slider.addEventListener('touchstart', pauseHandler, { passive: true });
      slider.addEventListener('mouseenter', pauseHandler);

      // Keep index in sync if the user manually scrolls
      var scrollSyncTimeout = null;
      slider.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollSyncTimeout);
          scrollSyncTimeout = setTimeout(function () {
            var step = slideStep();
            if (step > 0) {
              index = Math.round(slider.scrollLeft / step);
              updateActiveDot();
            }
          }, 150);
        },
        { passive: true }
      );

      if (dots) {
        dots.addEventListener('click', function (event) {
          var btn = event.target.closest('.press-reviews__dot');
          if (!btn) return;
          var i = parseInt(btn.dataset.slide, 10);
          if (Number.isFinite(i)) goToSlide(i);
        });
      }

      if (mq.addEventListener) {
        mq.addEventListener('change', start);
      } else if (mq.addListener) {
        mq.addListener(start);
      }

      renderDots();
      updateActiveDot();
      start();
    }

    function init() {
      document.querySelectorAll('.press-reviews__list.slider--mobile').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-our-team-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      if (slider.dataset.dotsInited) return;
      slider.dataset.dotsInited = 'true';

      var items = slider.querySelectorAll('.multicolumn-list__item');
      if (items.length < 2) return;

      var sliderComponent = slider.closest('slider-component');
      var dots = sliderComponent ? sliderComponent.querySelector('[data-our-team-dots]') : null;
      if (!dots) return;

      var index = 0;

      function slideStep() {
        var rect1 = items[0].getBoundingClientRect();
        var rect2 = items[1] ? items[1].getBoundingClientRect() : null;
        return rect2 ? rect2.left - rect1.left : rect1.width;
      }

      function renderDots() {
        var markup = '';
        for (var i = 0; i < items.length; i++) {
          markup +=
            '<button type="button" class="section-our-team__dot" role="tab" aria-label="Go to slide ' +
            (i + 1) +
            '" data-slide="' +
            i +
            '"></button>';
        }
        dots.innerHTML = markup;
        dots.removeAttribute('hidden');
      }

      function updateActiveDot() {
        var buttons = dots.querySelectorAll('.section-our-team__dot');
        for (var i = 0; i < buttons.length; i++) {
          var active = i === index;
          buttons[i].classList.toggle('is-active', active);
          buttons[i].setAttribute('aria-selected', active ? 'true' : 'false');
        }
      }

      function goToSlide(i) {
        index = Math.max(0, Math.min(items.length - 1, i));
        slider.scrollTo({ left: index * slideStep(), behavior: 'smooth' });
        updateActiveDot();
      }

      // Sync the active dot when the user swipes the strip.
      var scrollSyncTimeout = null;
      slider.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollSyncTimeout);
          scrollSyncTimeout = setTimeout(function () {
            var step = slideStep();
            if (step > 0) {
              index = Math.round(slider.scrollLeft / step);
              updateActiveDot();
            }
          }, 150);
        },
        { passive: true }
      );

      dots.addEventListener('click', function (event) {
        var btn = event.target.closest('.section-our-team__dot');
        if (!btn) return;
        var i = parseInt(btn.dataset.slide, 10);
        if (Number.isFinite(i)) goToSlide(i);
      });

      renderDots();
      updateActiveDot();
    }

    function init() {
      // Scope to .section-our-team so this doesn't also pick up the
      // multi-column-feature lists that share the .multicolumn-list class.
      document
        .querySelectorAll('.section-our-team .multicolumn-list.slider--mobile')
        .forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
